import { NavigationContext } from '../context/NavigationContext';
import { AuthContext } from '../context/AuthContext';
import React from 'react';
import { getIcon } from '../common/icon-mapping';
import '../i18n';
import { MenuItem } from './common/DataTypes';


export const SideMenu: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
    const context = React.useContext(NavigationContext);
    if (!context) {
        throw new Error('SideMenu must be used within a NavigationProvider');
    }
    const { navigateTo } = context;
    const authContext = React.useContext(AuthContext);
    if (!authContext) {
        throw new Error('SideMenu must be used within AuthProvider');
    }
    const { logout } = authContext;

    const eventMenu: MenuItem[] = [
        {
            id: 0,
            sectionNumber: 0,
            position: 0,
            iconId: '/home',
            name: "Startseite",
            section: "none",
            navigationPath: '/home',
        },
        {
            id: 1,
            sectionNumber: 0,
            position: 1,
            iconId: '/projects',
            name: "Abrechnungsprojekte",
            section: "none",
            navigationPath: '/projects',
        },
        {
            id: 4,
            sectionNumber: 0,
            position: 2,
            iconId: '/tischkonten',
            name: "Tischkonten",
            section: "none",
            navigationPath: '/tischkonten',
        },
        {
            id: 5,
            sectionNumber: 0,
            position: 3,
            iconId: 'sharing',
            name: "Tischkonten Imports",
            section: "none",
            navigationPath: '/imports/tischkonten',
        },
        {
            id: 8,
            sectionNumber: 0,
            position: 4,
            iconId: '/subscriptions',
            name: "Abonnements",
            section: "none",
            navigationPath: '/subscriptions',
        },
        {
            id: 6,
            sectionNumber: 1,
            position: 0,
            iconId: 'event',
            name: "Auswertung Starten",
            section: "Travelbingo",
            navigationPath: '/travelbingo',
        },
        {
            id: 7,
            sectionNumber: 1,
            position: 1,
            iconId: 'statistics',
            name: "Vorherige Auswertungen",
            section: "Travelbingo",
            navigationPath: '/travelbingo/evaluations',
        },
        {
            id: 3,
            sectionNumber: 2,
            position: 0,
            iconId: 'registration',
            name: "RTD Daten",
            section: "Einstellungen",
            navigationPath: '/settings',
        },
        {
            id: 2,
            sectionNumber: 2,
            position: 1,
            iconId: '/logout',
            name: "Logout",
            section: "Einstellungen",
            navigationPath: '/logout',
        },
    ];

    const handleNavigation = (path: string) => {
        navigateTo(path);
        if (path === '/logout') {
            logout();
        }
        onClose(); // Close the menu after navigation
    }

    return (
        <>
            {/* Backdrop overlay - clicking it closes the menu */}
            {isOpen && (
                <div
                    className="side-menu-backdrop"
                    onClick={onClose}
                    aria-label="Close menu overlay"
                />
            )}
            <div className={`side-menu ${isOpen ? 'open' : ''}`}>
                <div className="menu-header">
                    <img src={`/header.png`} alt="Header Grafik" className="menu-header-graphic" />
                </div>
                <div className="menu-content">
                    {eventMenu && eventMenu.length > 0 && (() => {
                        // Cluster by sectionNumber
                        const sectionMap: Record<number, any[]> = {};
                        eventMenu.forEach((item: any) => {
                            if (!sectionMap[item.sectionNumber]) sectionMap[item.sectionNumber] = [];
                            sectionMap[item.sectionNumber].push(item);
                        });
                        // Sort sectionNumbers
                        const sortedSections = Object.keys(sectionMap)
                            .map(Number)
                            .sort((a, b) => a - b);

                        return sortedSections.map(sectionNumber => {
                            const items = sectionMap[sectionNumber].sort((a, b) => (a.position ?? 0) - (b.position ?? 0));
                            const sectionHeader = items[0]?.section ? items[0].section : '';
                            return (
                                <div className="menu-block" key={sectionNumber}>
                                    <h4>{sectionHeader == "none" ? "Schatzmeister Toolbox" : sectionHeader}</h4>
                                    {items.map((item: any) => (
                                        <div
                                            className="menu-item"
                                            key={item.navigationPath}
                                            onClick={() => handleNavigation(item.navigationPath)}
                                        >
                                            <span className="menu-icon">
                                                {getIcon(item.iconId)}
                                            </span>
                                            <span className="menu-text">{item.name}</span>
                                        </div>
                                    ))}
                                </div>
                            );
                        });
                    })()}
                </div>
                <button className="menu-close-button" onClick={onClose} aria-label="Close Menu">
                    ✖
                </button>
            </div>
        </>
    );
};